import "./project.css"
import Logo from "../assets/ZG_Logo.png"
import Menu from "../components/menu";
import { Divider } from 'antd';


export default function Projects() {
    const projects = [
        {
            title: "ByteCode Interpreter",
            imgLink: "",
            link: "",
            comment: "A small Bytecode Intepretor."
        }
    ]

    const short_blurb = `
        Here is where I list of all the projects I am currently working on. I try to keep my project starting to a minimal
        so that I can actually finish a project! Let me know if a project interests you or if you have any tips on
        the project I am working on!
    `

    const finisher = "\"Don't be afraid to break things in the dark.\""

    return(
        <>
            <div className="master_container">
                <div className="navbar">
                    <div className="logo">
                        <img src={Logo} alt="logo" className="logo"></img>
                    </div>
                    <div className="navButtons_containers">
                        <Menu />
                    </div>
                    
                </div>
                <div className="content_container"> 
                    <div style={{textAlign: "center"}}>
                        <div>
                            <h1 id="project-queue-title">The Project Queue</h1>
                        </div>
                        <h2 id="tag">Things I wanted to do with code.</h2>
                    </div>
                    <div id="text_container">
                        <div className="text">
                            <p>{short_blurb}</p>
                        </div>
                        <div className="text-finisher">
                            <p>{finisher}</p>
                        </div>
                        <Divider/>
                        <div style={{textAlign: "center"}}>
                            <h2 id="tag">Projects</h2>
                            <p>In the works.</p>
                        </div>
                        {/* {
                            projects.map((e) => {
                                return(
                                    <div className="text">
                                        {
                                            e.imgLink === "" ? <></> : (
                                                <div align="center">
                                                    <a href={e.link}>
                                                        <img width="110px" height="110px" alt="Project Logo" src={e.imgLink}/>
                                                    </a>
                                                </div>
                                            )
                                        }
                                        <h2 id="project-title"><a href={e.link}>{e.title}</a></h2>
                                        <p style={{"margin-left": 300, "margin-right": 300}}>{e.comment}</p>
                                    </div>
                                )
                            })
                        } */}
                    </div>
                </div>
            </div>
        </>
    )
}